import { render, staticRenderFns } from "./UserPermissionsModal.vue?vue&type=template&id=127a3514&scoped=true&"
import script from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsModal.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./UserPermissionsModal.vue?vue&type=style&index=1&id=127a3514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a3514",
  null
  
)

export default component.exports